import { KompasNoDoorsConfigs } from "./kompas/mounts-no-door.config";
import { KompasSlidingDoorConfigs } from "./kompas/mounts-sliding-door.config";
import { KompasSwingDoorsConfigs } from "./kompas/mounts-swing-door.config";

export const KompasFramelessConfigs = {
    noDoors: KompasNoDoorsConfigs,
    slidingDoors: KompasSlidingDoorConfigs,
    swingDoors: KompasSwingDoorsConfigs,
};
